import VueCookies from "vue-cookies";
const state = {
  token: VueCookies.get("ACCESS_TOKEN") || "",
  userInfo:VueCookies.get("USER_INFO")||{},
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    VueCookies.set("ACCESS_TOKEN", token);
  },
  SET_USERINFO: (state, payload) => {
    state.userInfo = {...payload};

    // console.log(payload,"sssssssss");
    const info = { ...payload };
    VueCookies.set('USER_INFO', info);
    // VueCookies.set("USER_INFO", userInfo);
  },
  CLEAR_USERINFO: (state) => {
    state.userInfo = {};
    state.token = "";
    const cookiesArr = VueCookies.keys();
    cookiesArr.forEach(item => {
      VueCookies.remove(item);
    });
  },
};

const actions = {
  // 退出系统
  LogOut({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
        commit('CLEAR_USERINFO');
        resolve();
        // CLEAR_USERINFO()
    })
  },
  setToken({
    commit
  }, token) {
    commit("SET_TOKEN", token);
  },
  setUserInfo({
    commit
  }, payload) {
    console.log(payload,"payload");
    commit("SET_USERINFO", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
